module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.a613e81.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/roboto/Roboto-Bold.otf
// module id = QQdc
// module chunks = 0